import React from 'react';
import { Pause, Play, RefreshCw, Clock } from 'lucide-react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Button } from './ui/button';
import { Tooltip } from './ui/tooltip';
import { cn } from '../lib/utils';

dayjs.extend(relativeTime);

function AutoRefreshControl({
  isEnabled,
  toggle,
  refresh,
  isRefreshing,
  lastRefresh,
  secondsUntilRefresh,
}) {
  return (
    <div className="flex items-center gap-2">
      <Tooltip label={isEnabled ? 'Pause auto-refresh' : 'Enable auto-refresh'}>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={toggle}
          className={cn(isEnabled && 'text-success hover:text-success')}
        >
          {isEnabled ? <Pause /> : <Play />}
        </Button>
      </Tooltip>

      <Tooltip label="Refresh now">
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={refresh}
          disabled={isRefreshing}
          className="text-primary hover:text-primary"
        >
          <RefreshCw className={cn(isRefreshing && 'animate-spin')} />
        </Button>
      </Tooltip>

      <div className="flex flex-col items-end gap-0.5">
        <span
          className={cn(
            'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1',
            isEnabled
              ? 'bg-success/10 text-success ring-success/30'
              : 'bg-muted text-muted-foreground ring-border'
          )}
        >
          {isEnabled ? <Clock className="h-3 w-3" /> : <Pause className="h-3 w-3" />}
          {isEnabled ? `Next: ${secondsUntilRefresh}s` : 'Paused'}
        </span>
        <span className="text-[11px] text-muted-foreground">
          Last: {dayjs(lastRefresh).fromNow()}
        </span>
      </div>
    </div>
  );
}

export default AutoRefreshControl;
